var ProductName = /* @__PURE__ */ ((ProductName2) => {
  ProductName2["MEMBERSHIP_19_99_EUR_QUARTERLY"] = "membership_19_99_eur_quarterly";
  ProductName2["MEMBERSHIP_19_99_EUR_ANNUALLY"] = "membership_19_99_eur_annually";
  ProductName2["MEMBERSHIP_19_99_EUR_SINGLE"] = "membership_19_99_eur_single";
  ProductName2["MEMBERSHIP_9_99_EUR_ANNUALLY"] = "membership_9_99_eur_annually";
  ProductName2["MEMBERSHIP_BIDROOM_19_99_EUR_ANNUALLY"] = "membership_bidroom_19_99_eur_annually";
  ProductName2["MEMBERSHIP_COMPLETE_49_99_EUR_ANNUALLY"] = "membership_complete_49_99_eur_annually";
  ProductName2["MEMBERSHIP_COMPLETE_49_99_EUR_SINGLE"] = "membership_complete_49_99_eur_single";
  ProductName2["MEMBERSHIP_COMPLETE_64_99_EUR_ANNUALLY"] = "membership_complete_64_99_eur_annually";
  ProductName2["MEMBERSHIP_ESSENTIAL_19_99_EUR_ANNUALLY"] = "membership_essential_19_99_eur_annually";
  ProductName2["MEMBERSHIP_ESSENTIAL_19_99_EUR_SINGLE"] = "membership_essential_19_99_eur_single";
  ProductName2["MEMBERSHIP_ESSENTIAL_24_99_EUR_SINGLE"] = "membership_essential_24_99_eur_single";
  ProductName2["MEMBERSHIP_ESSENTIAL_22_49_EUR_SINGLE"] = "membership_essential_22_49_eur_single";
  ProductName2["MEMBERSHIP_ESSENTIAL_24_99_EUR_ANNUALLY"] = "membership_essential_24_99_eur_annually";
  ProductName2["MEMBERSHIP_TELEMEDICO_19_99_EUR_ANNUALLY"] = "membership_telemedico_19_99_eur_annually";
  ProductName2["MEMBERSHIP_9_99_EUR_SINGLE"] = "membership_9_99";
  ProductName2["MEMBERSHIP_FREE"] = "membership_free";
  ProductName2["MEMBERSHIP_FREEMIUM"] = "membership_freemium";
  ProductName2["MEMBERSHIP_COMPLETE_INTERNAL"] = "membership_complete_internal";
  ProductName2["MEMBERSHIP_COMPLETE_EXTERNAL"] = "membership_complete_external";
  ProductName2["AIRHELP_SMART_SINGLE"] = "airhelp_smart_single";
  ProductName2["AIRHELP_SMART_ANNUALLY"] = "airhelp_smart_annually";
  ProductName2["AIRHELP_PRO_ANNUALLY"] = "airhelp_pro_annually";
  ProductName2["AIRHELP_LITE_ANNUALLY"] = "airhelp_lite_annually";
  ProductName2["AIRHELP_PRO_INTERNAL"] = "airhelp_pro_internal";
  ProductName2["AIRHELP_PRO_EXTERNAL"] = "airhelp_pro_external";
  ProductName2["AIRHELP_SMART_EXTERNAL"] = "airhelp_smart_external";
  ProductName2["TRIP"] = "trip";
  ProductName2["TRIP_ESSENTIAL"] = "trip_essential";
  ProductName2["TRIP_COMPLETE"] = "trip_complete";
  ProductName2["KIWI_AHPLUS"] = "kiwi_ahplus";
  ProductName2["KIWI_AIR_LUGGAGE"] = "kiwi_air_luggage";
  ProductName2["KIWI_AHPLUS_AIR_LUGGAGE"] = "kiwi_ahplus_air_luggage";
  ProductName2["AGODA_AHPLUS_AIR_PAYOUT"] = "agoda_ahplus_air_payout";
  ProductName2["UPGRADE_TO_TRIP_COMPLETE"] = "upgrade_to_trip_complete";
  ProductName2["TEST_MEMBERSHIP"] = "test_membership";
  ProductName2["JUMPEOPLE_AHPLUS_LOUNGE_AIR_PAYOUT_AIR_LUGGAGE_020624"] = "jumpeople_ahplus_lounge_air_payout_air_luggage_020624";
  ProductName2["MICROSIGNALS_AHPLUS_010624"] = "microsignals_ahplus_010624";
  ProductName2["MICROSIGNALS_AHPLUS_AIR_LUGGAGE_010624"] = "microsignals_ahplus_air_luggage_010624";
  ProductName2["IN_SURE_BROKER_AHPLUS_240624"] = "in_sure_broker_ahplus_240624";
  ProductName2["IN_SURE_BROKER_AHPLUS_LOUNGE_240624"] = "in_sure_broker_ahplus_lounge_240624";
  ProductName2["JUMPEOPLE_AHPLUS_020624"] = "jumpeople_ahplus_020624";
  return ProductName2;
})(ProductName || {});
var PaymentFrequency = /* @__PURE__ */ ((PaymentFrequency2) => {
  PaymentFrequency2["NONE"] = "none";
  PaymentFrequency2["SINGLE"] = "single";
  PaymentFrequency2["QUARTERLY"] = "quarterly";
  PaymentFrequency2["ANNUALLY"] = "annually";
  return PaymentFrequency2;
})(PaymentFrequency || {});
var ProductPerk = /* @__PURE__ */ ((ProductPerk2) => {
  ProductPerk2["ESIM"] = "Esim";
  ProductPerk2["AIR_PAYOUT"] = "AirPayout";
  ProductPerk2["AIR_LUGGAGE"] = "AirLuggage";
  ProductPerk2["AIRPORT_TRANSFER"] = "AirportTransfer";
  ProductPerk2["LOUNGE_ACCESS"] = "LoungeAccess";
  ProductPerk2["CAR_RENTAL"] = "CarRental";
  ProductPerk2["FLIGHT_NOTIFICATION"] = "FlightNotification";
  ProductPerk2["JOURNEY_LOUNGE_ACCESS"] = "JourneyLoungeAccess";
  return ProductPerk2;
})(ProductPerk || {});
var AirLuggageStatus = /* @__PURE__ */ ((AirLuggageStatus2) => {
  AirLuggageStatus2["ACTIVE"] = "active";
  AirLuggageStatus2["ELIGIBLE"] = "eligible";
  AirLuggageStatus2["PARTNER_ERROR"] = "partner_error";
  AirLuggageStatus2["PAYOUT_FAILED"] = "payout_failed";
  AirLuggageStatus2["PAYOUT_SUCCESSFUL"] = "payout_successful";
  AirLuggageStatus2["PROCESSING_PAYMENT"] = "processing_payment";
  AirLuggageStatus2["PAYOUT_RETURNED"] = "payout_returned";
  AirLuggageStatus2["UNKNOWN"] = "unknown";
  AirLuggageStatus2["INELIGIBLE"] = "ineligible";
  AirLuggageStatus2["UNREGISTERED"] = "unregistered";
  AirLuggageStatus2["BLOCKED"] = "blocked";
  AirLuggageStatus2["BLOCKED_UNREGISTERED"] = "blocked_unregistered";
  AirLuggageStatus2["MANUAL_VERIFICATION_PENDING"] = "manual_verification_pending";
  AirLuggageStatus2["EXPIRED"] = "expired";
  AirLuggageStatus2["MEMBERSHIP_NOT_RENEWED"] = "membership_not_renewed";
  AirLuggageStatus2["REJECTED"] = "rejected";
  return AirLuggageStatus2;
})(AirLuggageStatus || {});
var AirPayoutStatus = /* @__PURE__ */ ((AirPayoutStatus2) => {
  AirPayoutStatus2["ACTIVE"] = "active";
  AirPayoutStatus2["ELIGIBLE"] = "eligible";
  AirPayoutStatus2["PARTNER_ERROR"] = "partner_error";
  AirPayoutStatus2["INELIGIBLE"] = "ineligible";
  AirPayoutStatus2["PAYOUT_FAILED"] = "payout_failed";
  AirPayoutStatus2["PAYOUT_SUCCESSFUL"] = "payout_successful";
  AirPayoutStatus2["PROCESSING_PAYMENT"] = "processing_payment";
  AirPayoutStatus2["UNKNOWN"] = "unknown";
  AirPayoutStatus2["PAYOUT_RETURNED"] = "payout_returned";
  AirPayoutStatus2["UNREGISTERED"] = "unregistered";
  AirPayoutStatus2["BLOCKED"] = "blocked";
  AirPayoutStatus2["BLOCKED_UNREGISTERED"] = "blocked_unregistered";
  AirPayoutStatus2["MANUAL_VERIFICATION_PENDING"] = "manual_verification_pending";
  AirPayoutStatus2["EXPIRED"] = "expired";
  AirPayoutStatus2["MEMBERSHIP_NOT_RENEWED"] = "membership_not_renewed";
  AirPayoutStatus2["REJECTED"] = "rejected";
  return AirPayoutStatus2;
})(AirPayoutStatus || {});
var AirPayoutDisruption = /* @__PURE__ */ ((AirPayoutDisruption2) => {
  AirPayoutDisruption2["CANCELATION_ONLY"] = "cancelation_only";
  AirPayoutDisruption2["CANCELATION_DELAY_DIVERSION"] = "cancelation_delay_diversion";
  return AirPayoutDisruption2;
})(AirPayoutDisruption || {});
var AirPayoutCoverage = /* @__PURE__ */ ((AirPayoutCoverage2) => {
  AirPayoutCoverage2["OUTBOUND_OR_INBOUND"] = "outbound_or_inbound";
  AirPayoutCoverage2["OUTBOUND_ONLY"] = "outbound_only";
  return AirPayoutCoverage2;
})(AirPayoutCoverage || {});
var CheckDeletableReason = /* @__PURE__ */ ((CheckDeletableReason2) => {
  CheckDeletableReason2["AIR_PAYOUT"] = "air_payout";
  CheckDeletableReason2["AIR_LUGGAGE"] = "air_luggage";
  CheckDeletableReason2["B2B"] = "b2b";
  CheckDeletableReason2["LOUNGES"] = "lounges";
  return CheckDeletableReason2;
})(CheckDeletableReason || {});
var AirBundleRejectionReason = /* @__PURE__ */ ((AirBundleRejectionReason2) => {
  AirBundleRejectionReason2["NO_CREDITS"] = "no_credits";
  AirBundleRejectionReason2["REJECTED"] = "rejected";
  return AirBundleRejectionReason2;
})(AirBundleRejectionReason || {});
var TripTier = /* @__PURE__ */ ((TripTier2) => {
  TripTier2["COMPLETE"] = "complete";
  TripTier2["ESSENTIAL"] = "essential";
  return TripTier2;
})(TripTier || {});
var ProductDisplayName = /* @__PURE__ */ ((ProductDisplayName2) => {
  ProductDisplayName2["AIRHELP_PLUS_WITH_LOUNGES_AND_AIR_LUGGAGE"] = "AirHelp+ with Lounges and AirLuggage";
  ProductDisplayName2["AIRHELP_PLUS_WITH_AIR_LUGGAGE_AND_AIR_PAYOUT"] = "AirHelp+ with AirLuggage and AirPayout";
  ProductDisplayName2["AIRHELP_PLUS"] = "AirHelp+";
  ProductDisplayName2["AIRHELP_PLUS_ESSENTIAL"] = "AirHelp+ Essential";
  ProductDisplayName2["AIRHELP_PLUS_COMPLETE"] = "AirHelp+ Complete";
  ProductDisplayName2["AIRHELP_PLUS_FREE"] = "AirHelp+ free";
  ProductDisplayName2["AIRHELP_PLUS_FREEMIUM"] = "AirHelp+ freemium";
  ProductDisplayName2["AIRHELP_PLUS_LUGGAGE"] = "AirHelp+ Luggage";
  ProductDisplayName2["AIRHELP_PLUS_ALT"] = "AirHelp Plus";
  ProductDisplayName2["AIR_LUGGAGE"] = "Air Luggage";
  ProductDisplayName2["AIRHELP_PLUS_AIR_LUGGAGE"] = "AirHelp Plus Air Luggage";
  ProductDisplayName2["AIRHELP_PLUS_AIR_PAYOUT"] = "AirHelp Plus Air Payout";
  ProductDisplayName2["AIRHELP_PLUS_COMPLETE_EMPLOYEE"] = "AirHelp+ Complete Employee";
  ProductDisplayName2["AIRHELP_PLUS_PRO"] = "AirHelp+ Pro";
  ProductDisplayName2["AIRHELP_PLUS_SMART"] = "AirHelp+ Smart";
  ProductDisplayName2["AIRHELP_PLUS_LITE"] = "AirHelp+ Lite";
  ProductDisplayName2["AIRHELP_PLUS_PRO_EMPLOYEE"] = "AirHelp+ Pro Employee";
  ProductDisplayName2["AIRHELP_PLUS_LOUNGE"] = "AirHelp+ Lounge";
  ProductDisplayName2["AIRHELP_PLUS_WITH_AIR_LUGGAGE"] = "AirHelp+ with AirLuggage";
  ProductDisplayName2["AIRHELP_PLUS_WITH_AIR_PAYOUT"] = "AirHelp+ with AirPayout";
  ProductDisplayName2["AIRHELP_PLUS_WITH_LOUNGES"] = "AirHelp+ with Lounges";
  ProductDisplayName2["AIRHELP_PLUS_LOUNGE_LUGGAGE"] = "AirHelp+ Lounge Luggage";
  ProductDisplayName2["UPGRADE_TO_TRIP_COMPLETE"] = "Upgrade to Trip Complete";
  return ProductDisplayName2;
})(ProductDisplayName || {});
var MembershipTier = /* @__PURE__ */ ((MembershipTier2) => {
  MembershipTier2["COMPLETE"] = "complete";
  MembershipTier2["ESSENTIAL"] = "essential";
  MembershipTier2["LITE"] = "lite";
  MembershipTier2["PRO"] = "pro";
  MembershipTier2["SMART"] = "smart";
  return MembershipTier2;
})(MembershipTier || {});
var InsuranceType = /* @__PURE__ */ ((InsuranceType2) => {
  InsuranceType2["AIR_PAYOUT"] = "air_payout";
  InsuranceType2["AIR_LUGGAGE"] = "air_luggage";
  return InsuranceType2;
})(InsuranceType || {});
var AirBundleDocumentFile = /* @__PURE__ */ ((AirBundleDocumentFile2) => {
  AirBundleDocumentFile2["PIR"] = "pirReference";
  AirBundleDocumentFile2["BOARDING"] = "boardingPassOrBookingReference";
  AirBundleDocumentFile2["PASSPORT"] = "passportOrId";
  AirBundleDocumentFile2["BAGGAGE_TAG"] = "baggageTag";
  return AirBundleDocumentFile2;
})(AirBundleDocumentFile || {});
var AirBundleDocumentParam = /* @__PURE__ */ ((AirBundleDocumentParam2) => {
  AirBundleDocumentParam2["PIR"] = "pir_reference";
  AirBundleDocumentParam2["BOARDING"] = "boarding_pass_or_booking_reference";
  AirBundleDocumentParam2["PASSPORT"] = "passport_or_id";
  AirBundleDocumentParam2["BAGGAGE_TAG"] = "baggage_tag";
  return AirBundleDocumentParam2;
})(AirBundleDocumentParam || {});
var BANK_INPUTS = /* @__PURE__ */ ((BANK_INPUTS2) => {
  BANK_INPUTS2["ABA"] = "aba";
  BANK_INPUTS2["ACCOUNT_NUMBER"] = "accountNumber";
  BANK_INPUTS2["CLABE"] = "clabe";
  BANK_INPUTS2["BANK_NAME"] = "bankName";
  BANK_INPUTS2["BANK_ADDRESS"] = "bankAddress";
  BANK_INPUTS2["BRANCH_NAME"] = "branchName";
  BANK_INPUTS2["BRANCH_CODE"] = "branchCode";
  BANK_INPUTS2["BANK_CODE"] = "bankCode";
  BANK_INPUTS2["BRANCH_AGENCY_CODE"] = "branchAgencyCode";
  BANK_INPUTS2["IBAN"] = "iban";
  BANK_INPUTS2["ROUTING_NUMBER"] = "routingNumber";
  BANK_INPUTS2["SWIFT"] = "swift";
  BANK_INPUTS2["TAX"] = "taxId";
  BANK_INPUTS2["BANK_CITY"] = "bankCity";
  BANK_INPUTS2["PHONE_NUMBER"] = "phoneNumber";
  BANK_INPUTS2["CHINESE_ID"] = "chineseId";
  BANK_INPUTS2["PROVINCE"] = "province";
  BANK_INPUTS2["IFSC_CODE"] = "ifscCode";
  BANK_INPUTS2["NATIONALITY"] = "nationality";
  BANK_INPUTS2["BIC_CODE"] = "bicCode";
  BANK_INPUTS2["SORT_CODE"] = "sortCode";
  BANK_INPUTS2["PAYMENT_CODE"] = "paymentCode";
  BANK_INPUTS2["NUBAN"] = "nuban";
  BANK_INPUTS2["BANK_MFO"] = "bankMfo";
  BANK_INPUTS2["BSB_CODE"] = "bsbCode";
  BANK_INPUTS2["BIN_OR_IIN"] = "binOrIin";
  BANK_INPUTS2["KNP_OR_UPDC"] = "knpOrUpdc";
  return BANK_INPUTS2;
})(BANK_INPUTS || {});
var ActivationStatus = /* @__PURE__ */ ((ActivationStatus2) => {
  ActivationStatus2["ACTIVE"] = "active";
  ActivationStatus2["INACTIVE"] = "inactive";
  return ActivationStatus2;
})(ActivationStatus || {});
var FeatureFlagState = /* @__PURE__ */ ((FeatureFlagState2) => {
  FeatureFlagState2["ON"] = "on";
  FeatureFlagState2["OFF"] = "off";
  return FeatureFlagState2;
})(FeatureFlagState || {});
var StripePaymentStatues = /* @__PURE__ */ ((StripePaymentStatues2) => {
  StripePaymentStatues2["SUCCEEDED"] = "succeeded";
  StripePaymentStatues2["REQUIRES_PAYMENT_METHOD"] = "requires_payment_method";
  return StripePaymentStatues2;
})(StripePaymentStatues || {});
export {
  ActivationStatus as A,
  BANK_INPUTS as B,
  CheckDeletableReason as C,
  FeatureFlagState as F,
  InsuranceType as I,
  MembershipTier as M,
  ProductName as P,
  StripePaymentStatues as S,
  TripTier as T,
  PaymentFrequency as a,
  ProductPerk as b,
  AirLuggageStatus as c,
  AirPayoutStatus as d,
  AirPayoutDisruption as e,
  AirPayoutCoverage as f,
  AirBundleRejectionReason as g,
  ProductDisplayName as h,
  AirBundleDocumentFile as i,
  AirBundleDocumentParam as j
};
//# sourceMappingURL=enums-9yWx2mG-.js.map
